import React from 'react';
import { DAPrice } from '@components';

const PegDAPrice = () => {
  return (
    <DAPrice
      title="PEG DA Prices"
      rootPath="/media/files/csv/index/peg/"
      breadcrumbRootLabel="peg-da-prices"
      searchPlaceholders={{
        0: 'Search year folder (e.g. 2026)',
        1: 'Search month folder (e.g. 03 or March)',
        2: 'Search filename (e.g. 01.03.2026.csv)',
        default: 'Search filename or date'
      }}
      levelLabels={{
        0: 'Year',
        1: 'Month',
        2: 'File',
        default: 'Folder'
      }}
    />
  );
};

export default PegDAPrice;
